import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, of, switchMap } from 'rxjs';
import { WindowStateActions } from './window.actions';
import { selectWindowStateState } from './window.reducer';
import { AuthTokenActions } from '../auth-token/auth-token.actions';
import { EmailTranscriptActions } from '../email-transcript/email-transcript.actions';
import { VaButtonActions } from '../va-button/va-button.actions';
import { selectPendingActionState } from '../pending-action/pending-action.reducer';
import { ChatWindowStates, PendingActionType } from '../../types/enum';

@Injectable({
  providedIn: 'root',
})
export class WindowStateEffects {
  constructor(private actions$: Actions, private store: Store) {}

  /*
   * If the window is minimized, we open it
   * Else, we start the session
   * */
  requestToOpenWindow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WindowStateActions.requestToOpenWindow),
      concatLatestFrom(() => this.store.select(selectWindowStateState)),
      switchMap(([, windowState]) => {
        if (
          windowState === ChatWindowStates.MINIMIZED ||
          windowState === ChatWindowStates.OPENED
        ) {
          return of(WindowStateActions.openWindow());
        } else {
          return of(AuthTokenActions.startSession());
        }
      })
    )
  );

  /*
   * Need to have this effect in order to dispatch a "single" close action
   * CloseWindow action will be used in the meta reducer to clear the state
   * */
  closeWindow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        EmailTranscriptActions.setSubmitted,
        EmailTranscriptActions.setFailed,
        VaButtonActions.onSessionExpired,
        WindowStateActions.endSessionToStartNew
      ),
      map(() => WindowStateActions.closeWindow())
    )
  );

  StartSessionAfterClosing$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WindowStateActions.closeWindow),
      concatLatestFrom(() => this.store.select(selectPendingActionState)),
      filter(
        ([, pendingActionState]) =>
          pendingActionState.type === PendingActionType.startNewSession
      ),
      map(([, pendingActionState]) =>
        WindowStateActions.requestToOpenWindow({
          context: pendingActionState.parameters,
        })
      )
    )
  );
}
